export default "__VITE_ASSET__BzYd_tnP__"